import type { App } from "vue";
import { vMaska } from "maska/vue";

export default function (app: App) {
  app.directive("maska", vMaska);
}
